import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import flatMap from 'lodash/flatMap';
import flow from 'lodash/flow';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import pick from 'lodash/pick';
import toLower from 'lodash/toLower';
import uniqBy from 'lodash/uniqBy';
import { createReducer } from '@reduxjs/toolkit';

import {
  ADMIN_GET_DESIGN_ITEMS,
  ADMIN_GET_SIDEBAR_MENU,
  ADMIN_GET_TEMPLATE_BLOCKS,
  ActionSuccessType,
} from 'constants/redux-actions';

const initState = {
  templateBlocks: [],
  globalTemplates: [],
  standaloneSites: [],
  networks: [],
  adminSites: {},
  networkDesignItems: {},
};

const adminUXReducer = createReducer(initState, {
  [ActionSuccessType(ADMIN_GET_TEMPLATE_BLOCKS)]: (prevState, action) => ({
    ...prevState,
    templateBlocks: get(action.payload, 'data', []),
  }),
  [ActionSuccessType(ADMIN_GET_SIDEBAR_MENU)]: (prevState, action) => {
    const standaloneSites = get(action.payload, 'data.sites', []);
    const networks = get(action.payload, 'data.networks', []);

    const allNetworks = flow(
      (networks) =>
        flatMap(networks, (network) => [
          pick(network, ['id', 'name']),
          ...map(get(network, 'children', []), (child) => pick(child, ['id', 'name'])),
        ]),
      (networks) => uniqBy(networks, 'id'),
      (networks) => sortBy(networks, [(item) => (item.name.startsWith('_') ? 0 : 1), (item) => toLower(item.name)]),
    )(networks);

    return {
      ...prevState,
      standaloneSites,
      networks: keyBy(networks, 'id'),
      allNetworks,
    };
  },
  [ActionSuccessType(ADMIN_GET_DESIGN_ITEMS)]: (prevState, action) => {
    const globalTemplates = get(action.payload, 'data.globalTemplates', []);
    const networks = get(action.payload, 'data.networks', []);

    return {
      ...prevState,
      globalTemplates,
      adminSites: keyBy(get(action.payload, 'data.sites', []), 'id'),
      networkDesignItems: keyBy(networks, 'id'),
    };
  },
});

export default adminUXReducer;
